export default "__VITE_ASSET__FDGHMdLT__"